export default __webpack_public_path__ + "static/media/hocsi.66925f17.png";